/* eslint-disable @typescript-eslint/no-explicit-any */
import {observable, React} from '@api'
import {ShapeStyles} from '@modules/whiteboard'
import {Utils} from '@tldraw/core'
import { HighlighterComponent, HighlighterIndicator } from '.'
import {DrawShape, DrawUtil} from '../draw/index'
import {DrawTool} from '@modules/whiteboard/tools/DrawTool'

export interface HighlighterShape extends Omit<DrawShape, 'type'> {
  type: 'highlighter'
}

type T = HighlighterShape
type E = SVGSVGElement

export class HighlighterTool extends DrawTool {
  override type = 'highlighter'
}

export class HighlighterUtil extends DrawUtil {
  override type = 'highlighter' as any

  canBind = true

  override getShape : any = (props: Partial<T>): T => {
    return Utils.deepMerge<T>(
      {
        id: 'id',
        type: 'highlighter',
        name: 'Highlighter',
        parentId: 'page',
        childIndex: 1,
        point: [0, 0],
        points: [],
        rotation: 0,
        isComplete: false,
        style: {
          ...this.tldraw.createDefaultStyle(),
          strokeWidth: 2,
          strokeColor: '#000000',
          backgroundColor: '#ffffff22',
          opacity: .17
        }
      },
      props
    )
  }

  Component = HighlighterComponent as any

  Indicator = HighlighterIndicator as any
}

/*
export interface NuHighlighterShapeProps extends TLNuDrawShapeProps, NuStyleProps {}

export class NuHighlighterShape extends TLNuDrawShape<NuHighlighterShapeProps> {
  constructor(props = {} as TLNuShapeProps & Partial<NuHighlighterShapeProps>) {
    super(props)
    assignOwnProps(this, props)
    makeObservable(this)
  }

  static id = 'highlighter'

  @observable stroke = '#000000'
  @observable fill = '#ffffff22'
  @observable strokeWidth = 2

  @computed get pointsPath() {
    const {points} = this
    return SvgPathUtils.getCurvedPathForPoints(points)
  }

  Component = observer(({events}: TLNuComponentProps) => {
    const {pointsPath, stroke, fill, strokeWidth} = this

    return (
      <SVGContainer {...events}>
        <path
          d={pointsPath}
          strokeWidth={strokeWidth * 16}
          stroke={stroke}
          fill={fill}
          pointerEvents="all"
          strokeLinejoin="round"
          strokeLinecap="round"
          opacity={0.17}
        />
      </SVGContainer>
    )
  })

  Indicator = observer((props: TLNuIndicatorProps) => {
    const {pointsPath} = this
    return <path d={pointsPath} fill="none"/>
  })
}
*/



// WEBPACK FOOTER //
// ./src/modules/whiteboard/shapes/highlighter/Highlighter.tsx